/*
  CB 15/10/2026 - Barra traguardi omaggi nel carrello laterale di Vitals.
  Il carrello laterale Vitals non mostra la barra di EGO Free Gift (EGO la monta
  solo nella tendina del tema e nella pagina /cart). Questa barra:
  - legge soglie, nomi dei traguardi e frasi dalla campagna EGO attiva
    (window.EgoFreeGiftSettings): se in EGO cambiano soglie o testi, cambia anche qui;
  - si posiziona in alto nel carrello Vitals, sotto il titolo "Carrello";
  - si aggiorna a ogni aggiunta, rimozione o cambio quantita' (osserva le chiamate
    /cart/add, /cart/change, /cart/update, /cart/clear di qualsiasi app o del tema)
    e ogni volta che il carrello si apre;
  - usa il totale del carrello dopo gli sconti, come EGO.
  Gli omaggi li aggiunge e li toglie sempre EGO: questo file mostra solo l'avanzamento.
  Stile in assets/cb-fixes-1510.css (blocco 3) e assets/cb-fixes-1510b.css.

  CB 15/10/2026 (pomeriggio):
  - la barra resta visibile anche con il carrello vuoto (riparte da zero);
  - pulsante "Svuota carrello" sotto l'elenco prodotti del carrello Vitals:
    /cart/clear.js (toglie tutto, omaggi EGO compresi), poi il carrello Vitals
    viene ricaricato (vtlsCartDrawer.hide/show: Vitals non si aggiorna da solo
    dopo /cart/clear.js), si aggiorna il numerino del carrello nell'header e la
    barra torna a zero. Stile in assets/cb-fixes-1510.css (blocco 3b).

  CB 15/10/2026 (sera):
  - sotto ogni scaglione compare la soglia di spesa da raggiungere (es. "€40"),
    letta da EGO come tutto il resto: si vedono sempre tutte le soglie, anche quelle
    successive alla prossima.
*/
(function () {
  var DRAWER = '#vitals-cart_drawer-container .Vtl-CartDrawer__Container'
  var HEADER = '.Vtl-CartDrawerHeader'
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/
  var cart = null
  var timers = []
  var busy = false

  var ICONS = {
    free_shipping:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6h11v9H2zM13 9h4l3 3v3h-7z"/><circle cx="6" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
    free_gift:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 9h18v4H3zM5 13v8h14v-8M12 9v12"/><path d="M12 9C10.5 5.5 6.5 5 6.5 7.3 6.5 9 12 9 12 9zM12 9c1.5-3.5 5.5-4 5.5-1.7C17.5 9 12 9 12 9z"/></svg>'
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
    })
  }

  function campaign() {
    var S = window.EgoFreeGiftSettings
    var list = S && S.settings && S.settings.active_campaigns
    if (!list || !list.length) return null
    for (var i = 0; i < list.length; i++) {
      var g = list[i].giftMilestoneSetting
      if (g && g.milestones && g.milestones.length && (!g.tieredRewardType || g.tieredRewardType === 'total_cart_value')) {
        var ms = g.milestones.slice().sort(function (a, b) { return a.buyAtLeast - b.buyAtLeast })
        var d = list[i].milestoneRewardDisplaySetting || {}
        return { milestones: ms, messages: d.milestones || [] }
      }
    }
    return null
  }

  function money(cents) {
    var S = window.EgoFreeGiftSettings || {}
    var fmt = S.money_format || '€{{amount_with_comma_separator}}'
    var n = Math.max(0, cents) / 100
    var parts = n.toFixed(2).split('.')
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1]
    var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1]
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/, withDot)
  }

  // Soglia sotto lo scaglione: senza decimali quando e' un importo tondo ("€40")
  function thresholdLabel(amount) {
    var cents = Math.round(amount * 100)
    var s = money(cents)
    return cents % 100 === 0 ? s.replace(/[,.]00(?!\d)/, '') : s
  }

  function paidItems(c) {
    var n = 0
    for (var i = 0; i < c.items.length; i++) {
      var p = c.items[i].properties || {}
      if (!p._EgoFreeGift && !p._Ego) n += c.items[i].quantity
    }
    return n
  }

  function build() {
    var C = campaign()
    if (!C) return null
    var el = document.createElement('div')
    el.className = 'cb-goals'
    el.setAttribute('role', 'status')
    el.setAttribute('aria-live', 'polite')
    var N = C.milestones.length
    var steps = ''
    for (var i = 0; i < N; i++) {
      var m = C.milestones[i]
      steps +=
        '<li class="cb-goals__step" style="left:' + ((i + 1) / N) * 100 + '%">' +
        '<span class="cb-goals__dot">' + (ICONS[m.type] || ICONS.free_gift) + '</span>' +
        '<span class="cb-goals__thr">' + esc(thresholdLabel(m.buyAtLeast)) + '</span>' +
        '<span class="cb-goals__label">' + esc(m.name) + '</span></li>'
    }
    el.innerHTML =
      '<p class="cb-goals__msg"></p>' +
      '<div class="cb-goals__track"><div class="cb-goals__line"><span class="cb-goals__fill"></span></div>' +
      '<ol class="cb-goals__steps">' + steps + '</ol></div>'
    return el
  }

  function render(el) {
    var C = campaign()
    if (!C || !el) return
    if (!cart) { el.hidden = true; return }
    el.hidden = false
    var total = cart.total_price
    var ms = C.milestones
    var N = ms.length
    var next = -1
    for (var i = 0; i < N; i++) {
      if (total < Math.round(ms[i].buyAtLeast * 100)) { next = i; break }
    }
    var pct
    if (next === -1) {
      pct = 100
    } else {
      var prevThr = next === 0 ? 0 : Math.round(ms[next - 1].buyAtLeast * 100)
      var thr = Math.round(ms[next].buyAtLeast * 100)
      var prevPos = next / N
      var pos = (next + 1) / N
      pct = (prevPos + ((total - prevThr) / (thr - prevThr)) * (pos - prevPos)) * 100
    }
    el.querySelector('.cb-goals__fill').style.width = Math.max(0, Math.min(100, pct)) + '%'
    var stepsEls = el.querySelectorAll('.cb-goals__step')
    for (var j = 0; j < stepsEls.length; j++) {
      stepsEls[j].classList.toggle('is-done', total >= Math.round(ms[j].buyAtLeast * 100))
    }
    var msg
    if (next === -1) {
      msg = esc(C.messages[N] || 'Hai ottenuto tutti i premi!')
    } else {
      var t = C.messages[next] || 'Ti mancano {{amount}} per: ' + ms[next].name
      var missing = Math.round(ms[next].buyAtLeast * 100) - total
      msg = esc(t).replace(/\{\{\s*amount\s*\}\}/g, '<strong>' + esc(money(missing)) + '</strong>')
    }
    var p = el.querySelector('.cb-goals__msg')
    if (p.innerHTML !== msg) p.innerHTML = msg
  }

  function mount() {
    var box = document.querySelector(DRAWER)
    if (!box) return null
    var el = box.querySelector(':scope > .cb-goals')
    var head = box.querySelector(':scope > ' + HEADER)
    if (!el) {
      el = build()
      if (!el) return null
      if (head && head.nextSibling) box.insertBefore(el, head.nextSibling)
      else if (head) box.appendChild(el)
      else box.insertBefore(el, box.firstChild)
      render(el)
    } else if (head && el.previousElementSibling !== head) {
      box.insertBefore(el, head.nextSibling)
    }
    return el
  }

  // ---- Svuota carrello ---------------------------------------------------
  var TRASH =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4h6v3"/></svg>'
  var clearing = false

  function mountClear() {
    var box = document.querySelector(DRAWER)
    if (!box) return
    var list = box.querySelector('.Vtl-CartDrawerProducts')
    var el = box.querySelector('.cb-drawer-clear')
    if (!list) { if (el) el.remove(); return }
    if (!el) {
      el = document.createElement('div')
      el.className = 'cb-drawer-clear'
      el.innerHTML = '<button type="button" class="cb-drawer-clear__btn">' + TRASH + '<span>Svuota carrello</span></button>'
    }
    if (el.previousElementSibling !== list) list.insertAdjacentElement('afterend', el)
    var show = !!(cart && paidItems(cart) > 0)
    if (el.hidden === show) el.hidden = !show
  }

  function updateHeaderCount(c) {
    var nums = document.querySelectorAll('.cart-link__bubble-num')
    for (var i = 0; i < nums.length; i++) nums[i].textContent = c.item_count
    var bubbles = document.querySelectorAll('.cart-link__bubble')
    for (var j = 0; j < bubbles.length; j++) bubbles[j].classList.toggle('cart-link__bubble--visible', c.item_count > 0)
  }

  function clearCart(btn) {
    if (clearing) return
    clearing = true
    btn.classList.add('is-loading')
    var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/')
    fetch(root + 'cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
    })
      .then(function () {
        return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      })
      .then(function (r) { return r.json() })
      .then(function (c) {
        cart = c
        updateHeaderCount(c)
        var el = mount()
        if (el) render(el)
        // Vitals non si accorge di /cart/clear.js: si ricarica il suo carrello
        var d = window.vtlsCartDrawer
        if (d && typeof d.hide === 'function' && typeof d.show === 'function') {
          d.hide()
          setTimeout(function () { d.show() }, 320)
        }
      })
      .catch(function () {})
      .then(function () {
        clearing = false
        btn.classList.remove('is-loading')
      })
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.cb-drawer-clear__btn') : null
    if (!btn) return
    e.preventDefault()
    e.stopPropagation()
    clearCart(btn)
  }, true)

  function refresh() {
    if (busy) return
    busy = true
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json() })
      .then(function (c) {
        cart = c
        var el = mount()
        if (el) render(el)
        mountClear()
      })
      .catch(function () {})
      .then(function () { busy = false })
  }

  // Dopo un cambio al carrello: subito, poi di nuovo quando EGO ha aggiunto/tolto gli omaggi
  function scheduleRefresh() {
    for (var i = 0; i < timers.length; i++) clearTimeout(timers[i])
    timers = [setTimeout(refresh, 350), setTimeout(refresh, 1500), setTimeout(refresh, 3500)]
  }

  function watchNetwork() {
    if (!('PerformanceObserver' in window)) return
    try {
      new PerformanceObserver(function (list) {
        var entries = list.getEntries()
        for (var i = 0; i < entries.length; i++) {
          if (CART_RE.test(entries[i].name)) { scheduleRefresh(); return }
        }
      }).observe({ type: 'resource', buffered: false })
    } catch (e) {}
  }

  function watchDrawer() {
    var wasOpen = false
    var pending = false
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target
        if (t && t.closest && t.closest('.cb-goals, .cb-drawer-clear')) continue
        if (pending) return
        pending = true
        requestAnimationFrame(function () {
          pending = false
          var box = document.querySelector(DRAWER)
          var open = !!box
          if (open) {
            var el = mount()
            if (el && cart) render(el)
            mountClear()
            if (!wasOpen) refresh()
          }
          wasOpen = open
        })
        return
      }
    }).observe(document.body, { childList: true, subtree: true })
  }

  function start() {
    if (!campaign()) {
      // EGO carica le impostazioni in modo asincrono: riprova per qualche secondo
      var tries = 0
      var iv = setInterval(function () {
        if (campaign() || ++tries > 20) {
          clearInterval(iv)
          if (campaign()) start()
        }
      }, 500)
      return
    }
    watchNetwork()
    watchDrawer()
    refresh()
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start)
  else start()
})()